import CryptoJS from "crypto-js";

export default function(word, pw) {
  let key = CryptoJS.enc.Utf8.parse(pw);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
